<template>
  <div id="app">
    <RomaLayout />
  </div>
</template>

<script>

import RomaLayout from "@/components/core/RomaLayout";

export default {
  components: {
    RomaLayout
  },
};
</script>


<style lang="scss"></style>
